//import Moment from "moment";

const getCount = (state) => {
	return state.marcaEquipamentos.length;
}

export default {
	getCount
}